(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BT-Silder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var sw = new Swiper('.theme-slider-wrapper', {
      direction: 'horizontal',
      grabCursor: true,
      simulateTouch: true,
      followFinger: true,
      loop: false,
      breakpoints: {
        0: { slidesPerView: 1.25, spaceBetween: 8, loop: false },
        375: { slidesPerView: 1.27, spaceBetween: 10, loop: false },
        480: { slidesPerView: 1.25, spaceBetween: 12, loop: false },
        768: { slidesPerView: 1.5, spaceBetween: 15, loop: false },
        1024: { slidesPerView: 1.5, spaceBetween: 15, loop: false },
        1440: { slidesPerView: 1.58, spaceBetween: 16, loop: false },
        1800: { slidesPerView: 2.5, spaceBetween: 15, loop: false }
      }
    });

    // Arrow click handlers
    var wrapper = document.querySelector('.theme-slider-wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.ts-arrow').forEach(function(btn) {
        btn.addEventListener('click', function() {
          btn.classList.contains('ts-prev') ? sw.slidePrev() : sw.slideNext();
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-slider-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.theme-slider-pages', {
     
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      direction: 'horizontal',
      grabCursor: true,        // shows grab cursor
      simulateTouch: true,     // allow dragging with mouse
      followFinger: true,  
      breakpoints: {
        390: { 
          slidesPerView: 1.05, 
          spaceBetween: 8 ,
          loop : false
        },
        576: { 
          slidesPerView:  1.05, 
          spaceBetween: 8 ,
          loop : false
        },
        900: { 
          slidesPerView: 1.05, 
          spaceBetween: 15 ,
          loop:false
        },
        1800: { 
        slidesPerView: 2.4, 
        spaceBetween: 15 ,
        loop:false
      }
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
